import { createFileRoute, useParams } from "@tanstack/react-router";

import { EpisodePage } from "@/components/explore/episode-page";
import { episodeQuery } from "@/lib/queries";
import { queryClient } from "@/lib/query-client";

const EpisodeRoute = () => {
  const { episodeId } = useParams({ from: "/view/episodes/$episodeId" });

  return <EpisodePage episodeId={episodeId} />;
};

export const Route = createFileRoute("/view/episodes/$episodeId")({
  component: EpisodeRoute,

  // Usually a cache hit: the list the visitor clicked from seeded this entry.
  loader: ({ params }) =>
    queryClient.ensureQueryData(episodeQuery(params.episodeId)),
});
